module.exports = __webpack_public_path__ + "img/ring_r_o_1_0@2x.68f32e6c.png";